import { render } from "./TableFooter.vue?vue&type=template&id=7946dab1&scoped=true"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"

import "./TableFooter.vue?vue&type=style&index=0&id=7946dab1&scoped=true&lang=css"

import exportComponent from "/var/www/EasternFront_new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7946dab1"]])

export default __exports__